const slugRgx = '[.][A-z0-9-\\s]+';

const playerPathRegexp = `/:rootId(entry-section${slugRgx})/:sectionId(section${slugRgx})?/:pageId(page${slugRgx})?/`;

export default playerPathRegexp;
